import React, { useEffect, useRef } from 'react';
import {
  ColumnContainer,
  Heading,
  LoginBackImage,
  LoginContainer,
  LoginWrapper,
  Logo,
  LogoWrap,
  PartialWrapLoginBackImage,
  Wrap,
} from 'pages/login/login_style';
import html2canvas from 'html2canvas';
import ThumnailLogin from './thumbnail_login';

const Thumbnail = ({
  showBackImage,
  backgroundColor,
  buttonColor,
  buttonTextColor,
  defaultTheme,
  onCapture,
  backgroundImage,
  logo,
}) => {
  const thumbnailRef = useRef(null);

  useEffect(() => {
    const captureThumbnail = async () => {
      const thumbnail = thumbnailRef.current;
      if (thumbnail) {
        try {
          const images = thumbnail.getElementsByTagName('img');
          const promises = Array.from(images).map((img) => {
            img.crossOrigin = 'anonymous';
            if (!img.complete) {
              return new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = reject;
              });
            }
            return Promise.resolve();
          });
          await Promise.all(promises);

          const canvas = await html2canvas(thumbnail, {
            useCORS: true,
            windowWidth: 1920,
            windowHeight: 1080,
            scale: 1,
          });
          const imgData = canvas.toDataURL('image/png');
          onCapture(imgData);
        } catch (error) {
          return error;
        }
      }
    };
    const timeoutId = setTimeout(captureThumbnail, 500);
    return () => clearTimeout(timeoutId);
  }, [onCapture]);

  return (
    <>
      <div ref={thumbnailRef}>
        {defaultTheme === 'globlue' ? (
          <LoginBackImage
            backgroundimage={encodeURI(backgroundImage)}
            showBackImage={showBackImage}
            backgroundColor={backgroundColor}
            className='login-background-image thumbnail-capture'
          >
            <ColumnContainer className='globlue login-column-container'>
              <div className='column' />
              <div className='column'>
                <Wrap className='login-wrapper thumbnail-capture'>
                  <LoginContainer className='login-container'>
                    <LogoWrap className='login-logo-wrap'>
                      <Logo src={logo} alt='Logo' className='login-logo' />
                    </LogoWrap>
                    <ThumnailLogin buttonColor={buttonColor} buttonTextColor={buttonTextColor} theme={defaultTheme} />
                  </LoginContainer>
                </Wrap>
              </div>
            </ColumnContainer>
          </LoginBackImage>
        ) : defaultTheme === 'mornglow' ? (
          <PartialWrapLoginBackImage
            backgroundColor={backgroundColor}
            className='mornglow login-partial-wrapper thumbnail-capture'
          >
            <ColumnContainer className='mornglow login-column-container'>
              <div className='column'>
                <Wrap className='logoleft login-wrapper thumbnail-capture'>
                  <Logo src={logo} className='leftsideLogo login-logo' alt='Logo' />
                  <LoginWrapper className={`${defaultTheme} login-inside-wrap`}>
                    <LoginContainer className='login-container'>
                      <Heading className={`${defaultTheme} login-heading`}>Login</Heading>
                      <ThumnailLogin buttonColor={buttonColor} buttonTextColor={buttonTextColor} theme={defaultTheme} />
                    </LoginContainer>
                  </LoginWrapper>
                </Wrap>
              </div>
            </ColumnContainer>
            <LoginBackImage
              showBackImage={showBackImage}
              backgroundColor={backgroundColor}
              backgroundimage={encodeURI(backgroundImage)}
              className='login-background-image thumbnail-capture'
            ></LoginBackImage>
          </PartialWrapLoginBackImage>
        ) : defaultTheme === 'nitrate' ? (
          <LoginBackImage
            backgroundimage={encodeURI(backgroundImage)}
            showBackImage={showBackImage}
            backgroundColor={backgroundColor}
            className='login-background-image thumbnail-capture'
          >
            <ColumnContainer className='nitrate login-column-container'>
              <Wrap className='login-wrapper thumbnail-capture'>
                <LoginWrapper className={`${defaultTheme} login-inside-wrap`}>
                  <LoginContainer className='login-container'>
                    <LogoWrap className='login-logo-wrap'>
                      <Logo src={logo} alt='Logo' className='login-logo' />
                    </LogoWrap>
                    <ThumnailLogin buttonColor={buttonColor} buttonTextColor={buttonTextColor} theme={defaultTheme} />
                  </LoginContainer>
                </LoginWrapper>
              </Wrap>
            </ColumnContainer>
          </LoginBackImage>
        ) : defaultTheme === 'teamring' ? (
          <PartialWrapLoginBackImage
            backgroundColor={backgroundColor}
            className='login-partial-wrapper thumbnail-capture'
          >
            <LoginBackImage
              showBackImage={showBackImage}
              backgroundColor={backgroundColor}
              backgroundimage={encodeURI(backgroundImage)}
              className='login-background-image thumbnail-capture'
            >
              <Wrap className='logoleft login-wrapper thumbnail-capture'>
                <Logo src={logo} className='leftsideLogo login-logo' alt='Logo' />
              </Wrap>
            </LoginBackImage>
            <ColumnContainer className='teamring login-column-container'>
              <Wrap className='login-wrapper-second thumbnail-capture'>
                <LoginWrapper className={`${defaultTheme} login-inside-wrap`}>
                  <LoginContainer className='login-container'>
                    <Heading className={`${defaultTheme} login-heading`}>Login</Heading>
                    <ThumnailLogin buttonColor={buttonColor} buttonTextColor={buttonTextColor} theme={defaultTheme} />
                  </LoginContainer>
                </LoginWrapper>
              </Wrap>
            </ColumnContainer>
          </PartialWrapLoginBackImage>
        ) : null}
      </div>
    </>
  );
};

export default Thumbnail;
